// extracted by mini-css-extract-plugin
export default {"conditions":"TermsAndConditions_conditions__FNaR9"};